import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledComboboxEmptyState } from './ComboboxEmptyState.styles';

/**
 * @extends Paragraph
 * @since 8.28.0
 */
export var ComboboxEmptyState = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledComboboxEmptyState, _extends({
    ref: forwardedRef
  }, props));
});
ComboboxEmptyState.displayName = 'ComboboxEmptyState';
ComboboxEmptyState.defaultProps = {
  paddingX: 'sm',
  paddingY: 1.5,
  fontColor: 'textMedium',
  children: 'No matches found.'
};